export default {
	get: function() {
		return this.value;
	},
	set: function(newValue) {
		this.$emit('input', newValue);
	}
}



// WEBPACK FOOTER //
// ./src/libs/vModelNested.js